"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquirtleSquadApiClient = void 0;
const logger_1 = require("@madbox/logger");
const form_data_1 = __importDefault(require("form-data"));
const api_client_1 = require("@madbox/api_client");
class SquirtleSquadApiClient extends api_client_1.ApiClient {
    constructor() {
        super(...arguments);
        // Methods
        this.Member = {
            signup: (mail, password, firstname, lastname) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'public', 'member/signup', { mail, password, firstname, lastname }, {});
                this.apiRequestor.setToken(response.token);
                return response.token;
            }),
            login: (options) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'public', 'member/login', options, {});
                this.apiRequestor.setToken(response.token);
                return response.token;
            }),
            get: (optionsWith = {}, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'admin', 'member/get', { withOrganizations: optionsWith.withOrganizations, withApplications: optionsWith.withApplications, withTeams: optionsWith.withTeams }, auth);
                return response.profile;
            }),
            getOrganizations: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'admin', 'member/get/organizations', {}, auth);
                return response.organizations;
            }),
            getApplications: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'member/get/applications', {}, auth);
                return response.applications;
            }),
            getList: (memberIds, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'secure', 'member/list', { memberIds }, auth);
                return response.members;
            }),
            update: (mail, firstname, lastname, profilePicture, spokenLanguages, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const body = new form_data_1.default();
                body.append('mail', mail);
                body.append('firstname', firstname);
                body.append('lastname', lastname);
                body.append('spoken_languages', spokenLanguages);
                if (profilePicture)
                    body.append('profile_picture', profilePicture, 'profile_picture');
                yield this.post('api', 'admin', 'member/update/profile', body, auth);
            }),
            updatePassword: (oldPassword, newPassword, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post('api', 'admin', 'member/update/password', { oldPassword, newPassword }, auth);
            }),
            forgotPassword: (mail) => __awaiter(this, void 0, void 0, function* () {
                yield this.post('api', 'public', 'member/password/recover', { mail }, {});
            }),
            getAuthorizations: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'admin', 'member/authorizations/get', {}, auth);
                return response.authorizations;
            }),
            disableAccount: (memberId, isDisabled, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post('api', 'admin', 'member/disable/account', { memberId, isDisabled }, auth);
            }),
            Organization: {
                getAll: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    const response = yield this.post('api', 'admin', 'member/organization/get/all', {}, auth);
                    return response.organizations;
                }),
            },
        };
        this.Organization = {
            create: (name, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'admin', 'organization/create', { name }, auth);
                return response.organization;
            }),
            get: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'organization/get', {}, auth);
                return response.organization;
            }),
            update: (entityId, name, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'org-admin', 'organization/update', { name }, auth);
            }),
            getApplications: (entityId, withArchived, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'organization/get/applications', { withArchived }, auth);
                return response.applications;
            }),
            Member: {
                invite: (entityId, member, teamsIds, authScopes, profilePicture, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    const body = new form_data_1.default();
                    body.append('member', JSON.stringify(member));
                    body.append('teamsIds', JSON.stringify(teamsIds));
                    body.append('authScopes', JSON.stringify(authScopes));
                    if (profilePicture)
                        body.append('profile_picture', profilePicture, 'profile_picture');
                    const response = yield this.post(entityId, 'org-admin', 'organization/member/invite', body, auth);
                    return response.member_id;
                }),
                remove: (entityId, memberId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    yield this.post(entityId, 'org-admin', 'organization/member/remove', { memberId }, auth);
                }),
                getByTeam: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    const response = yield this.post(entityId, 'org-admin', 'organization/team/get/members', {}, auth);
                    return response.teams_members;
                }),
                getAll: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    const response = yield this.post(entityId, 'org-admin', 'organization/member/get/all', {}, auth);
                    return response.members;
                }),
                getAuthorizations: (entityId, memberId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    const response = yield this.post(entityId, 'org-admin', 'organization/member/get/authorizations', { memberId }, auth);
                    return response.authorizations;
                }),
                update: (entityId, memberId, member, authScopes, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    yield this.post(entityId, 'org-admin', 'organization/member/update', { memberId, member, authScopes }, auth);
                }),
                updateSlackIdOrTrelloId: (entityId, params, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    yield this.post(entityId, 'org-admin', 'organization/member/update/slackIdOrTrelloId', params, auth);
                }),
            },
            Team: {
                getAll: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    const response = yield this.post(entityId, 'org-admin', 'organization/team/get/all', {}, auth);
                    return response.teams;
                }),
            },
        };
        this.Application = {
            create: (entityId, params, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'application/create', params, auth);
                return response.application;
            }),
            getAll: (withArchived, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'secure', 'application/get/all', { withArchived }, auth);
                return response.applications;
            }),
            get: (entityId, entityIds, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'application/get', { entityIds }, auth);
                return response.applications;
            }),
            getOne: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'app-admin', 'application/get/one', {}, auth);
                return response.application;
            }),
            update: (entityId, params, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'app-admin', 'application/update', params, auth);
            }),
            updateIcon: (entityId, formData, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'app-admin', 'application/update', formData, auth);
            }),
            join: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'org-admin', 'application/join', {}, auth);
            }),
            archive: (entityId, archive, services, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'app-admin', 'application/archive', { archive, services }, auth);
            }),
            Member: {
                invite: (entityId, memberId, authScopes, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    yield this.post(entityId, 'app-admin', 'application/member/invite', { memberId, authScopes }, auth);
                }),
                remove: (entityId, memberId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    yield this.post(entityId, 'app-admin', 'application/member/remove', { memberId }, auth);
                }),
            },
        };
        this.ApplicationType = {
            getAll: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'admin', 'application-type/get/all', {}, auth);
                return response.applications_types;
            }),
        };
        this.Team = {
            create: (entityId, team_id, name, authScopes, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'team/create', { team_id, name, authScopes }, auth);
                return response.team;
            }),
            get: (entityId, teamId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'team/get', { teamId }, auth);
                return response.team;
            }),
            update: (entityId, teamId, name, authScopes, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'org-admin', 'team/update', { teamId, name, authScopes }, auth);
            }),
            remove: (entityId, teamId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'org-admin', 'team/remove', { teamId }, auth);
            }),
            Member: {
                invite: (entityId, memberId, teamId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    yield this.post(entityId, 'org-admin', 'team/member/invite', { memberId, teamId }, auth);
                }),
                remove: (entityId, memberId, teamId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                    yield this.post(entityId, 'org-admin', 'team/member/remove', { memberId, teamId }, auth);
                }),
            },
        };
        this.Track = {
            create: (entityId, params, file, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const body = new form_data_1.default();
                body.append('params', JSON.stringify(params));
                if (file)
                    body.append('file', file, 'file');
                const response = yield this.post(entityId, 'org-admin', 'track/create', body, auth);
                return response.track;
            }),
            getOne: (entityId, track_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'track/get', { track_id }, auth);
                return response.track;
            }),
            getAll: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'track/get/all', {}, auth);
                return response.tracks;
            }),
            update: (entityId, track_id, params, file, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const body = new form_data_1.default();
                body.append('track_id', track_id);
                body.append('params', JSON.stringify(params));
                if (file)
                    body.append('file', file, 'file');
                const response = yield this.post(entityId, 'org-admin', 'track/update', body, auth);
                return response.track;
            }),
            remove: (entityId, track_id, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post(entityId, 'org-admin', 'track/remove', { track_id }, auth);
            }),
        };
        this.ApiService = {
            scopesGet: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'api_service/scopes/get', {}, auth);
                return response.scopes;
            }),
            getScopes: (entityId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post(entityId, 'org-admin', 'api_service/scopes/get', {}, auth);
                return response.scopes;
            }),
            getHeader: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'admin', 'api_service/header/get', {}, auth);
                return response.header;
            }),
            getAll: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'master', 'api_service/get/all', {}, auth);
                return response.api_services;
            }),
            create: (apiService, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'master', 'api_service/create', Object.assign(Object.assign({}, apiService), { apiServiceId: apiService.id }), auth);
                return response.api_service;
            }),
            update: (apiService, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post('api', 'master', 'api_service/update', Object.assign(Object.assign({}, apiService), { apiServiceId: apiService.id }), auth);
            }),
            remove: (apiServiceId, auth = {}) => __awaiter(this, void 0, void 0, function* () {
                yield this.post('api', 'master', 'api_service/remove', { apiServiceId }, auth);
            }),
        };
        this.StudioLocation = {
            getAll: (auth = {}) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.post('api', 'admin', 'studio-location/get/all', {}, auth);
                return response.studios_locations;
            }),
        };
    }
    get DEFAULT_API_URL() {
        return 'https://squirtle-squad-api.madbox.io';
    }
    static get instance() {
        if (!SquirtleSquadApiClient._instance) {
            logger_1.Logger.warn("SquirtleSquadApiClient hasn't been initialized. It will use the default values. SquirtleSquadApiClient.init(config) should be called before using it.");
            SquirtleSquadApiClient._instance = new SquirtleSquadApiClient();
        }
        return SquirtleSquadApiClient._instance;
    }
    static init(config = {}) {
        if (SquirtleSquadApiClient._instance) {
            logger_1.Logger.warn('SquirtleSquadApiClient has already been initialized. Overriding current configuration with the new one.');
            SquirtleSquadApiClient.instance.init(config);
        }
        else
            SquirtleSquadApiClient._instance = new SquirtleSquadApiClient(config);
        return SquirtleSquadApiClient.instance;
    }
}
exports.SquirtleSquadApiClient = SquirtleSquadApiClient;
